module.exports = __webpack_public_path__ + "static/media/opening_team.48fc6815.jpg";